export default "__VITE_ASSET__CzFB9MiV__"